import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useTypedSelector } from '@redux/Hooks/storeSelectors';
import { selectMapLayerIdByEntityName } from '@redux/selectors/selectors';
import EntityManagerCleaner from '../entities/EntityManagerCleaner';
import EntityEditor from '../entities/EntityEditor';
import { ScenarioEventsEntityName } from '@api/types/types';

const PopulationEventEdit = () => {
    const entityName = ScenarioEventsEntityName.PopulationEvent;
    const { populationEventId } = useParams<any>();
    const stopsLayerId = useTypedSelector(state => selectMapLayerIdByEntityName(state, entityName));

    const onSaveFn = useCallback(
        (entity: any) => {
            if (!populationEventId) {
                return `../${entity.id}/edit`;
            }
        },
        [populationEventId]
    );

    const onDeleteFn = useCallback(() => '../../', []);

    return (
        <EntityManagerCleaner entityName={entityName}>
            <EntityEditor
                entityId={populationEventId!}
                entityName={entityName}
                layerId={stopsLayerId}
                presetProperty={'scenarioCasePreset'}
                getUrlOnSaveFn={onSaveFn}
                getUrlOnDeleteFn={onDeleteFn}
                showDeleteBtn={!!populationEventId}
            />
        </EntityManagerCleaner>
    );
};

export default PopulationEventEdit;
